module.exports = function(app) {
    // data-ng-model-options="{ updateOn: 'default', debounce: 1000 }"  must be added to input element
    app.directive('currencyInputFormatter', function() {
       return {
           require: 'ngModel',
           restrict: 'A',
           scope: {
               model: '=currencyInputFormatter'
           },
           link: function(scope, elem, attrs, ctrl) {
               var formatViewValue = function() {
                   if (ctrl.$viewValue && !(ctrl.$viewValue.match(/\.\d{2}/))) {
                       ctrl.$setViewValue(Number(ctrl.$viewValue).toFixed(2));
                       ctrl.$render();
                   }
               };

               scope.$watch('model', formatViewValue);
               elem.blur(formatViewValue);
           }
       };
    });
};